/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSelectToken.vue?vue&type=template&id=23121715&scoped=true"
import script from "./popSelectToken.vue?vue&type=script&lang=js"
export * from "./popSelectToken.vue?vue&type=script&lang=js"
import style0 from "./popSelectToken.vue?vue&type=style&index=0&id=23121715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23121715",
  null
  
)

export default component.exports